"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.IconPlayFilled = void 0;
var _react = _interopRequireDefault(require("react"));
var AccessibleIcon = _interopRequireWildcard(require("@radix-ui/react-accessible-icon"));
var _Icons = require("../Icons.constants");
var _IconModule = _interopRequireDefault(require("../Icon.module.css"));
var _classnames = _interopRequireDefault(require("classnames"));
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
var IconPlayFilled = _ref => {
  var className = _ref.className,
    _ref$label = _ref.label,
    label = _ref$label === void 0 ? _Icons.DEFAULT_LABEL : _ref$label,
    _ref$color = _ref.color,
    color = _ref$color === void 0 ? _Icons.DEFAULT_COLOR : _ref$color,
    _ref$size = _ref.size,
    size = _ref$size === void 0 ? _Icons.DEFAULT_SIZE : _ref$size;
  return /*#__PURE__*/_react.default.createElement("div", {
    style: {
      height: size,
      width: size
    },
    className: (0, _classnames.default)(className, _IconModule.default.Container)
  }, /*#__PURE__*/_react.default.createElement(AccessibleIcon.Root, {
    label: label
  }, /*#__PURE__*/_react.default.createElement("svg", {
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/_react.default.createElement("path", {
    d: "M5 4.98963C5 4.01847 5 3.53289 5.20249 3.26522C5.37889 3.03203 5.64852 2.88773 5.9404 2.8703C6.27544 2.8503 6.67946 3.11965 7.48752 3.65835L18.0031 10.6687C18.6708 11.1139 19.0046 11.3364 19.1209 11.6169C19.2227 11.8622 19.2227 12.1378 19.1209 12.3831C19.0046 12.6636 18.6708 12.8862 18.0031 13.3313L7.48752 20.3417C6.67946 20.8804 6.27544 21.1497 5.9404 21.1297C5.64852 21.1123 5.37889 20.968 5.20249 20.7348C5 20.4671 5 19.9815 5 19.0104V4.98963Z",
    fill: color
  }))));
};
exports.IconPlayFilled = IconPlayFilled;
//# sourceMappingURL=IconPlayFilled.js.map